import {css} from '@emotion/react'

export const productCareStyles = css`
    .careTitle {
        font-size: var(--chakra-fontSizes-md);
        padding-bottom: 10px;
    }
    li {
        position: relative;
        padding-left: 8px;
        margin-bottom: 8px;
    }
    ul {
        color: var(--chakra-colors-darkGray);
        list-style-type: none;
    }
    li::before {
        content: '';
        position: absolute;
        top: 5px;
        left: 0;
        width: 0;
        height: 0;
        border-top: 3px solid transparent;
        border-bottom: 3px solid transparent;
        border-left: 4px solid var(--chakra-colors-darkGray);
    }
`
